[
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
        "uuid": "8de66fb2-a0ec-485b-b640-1d6cf9727b29",
        "simulationName": "Addressing Doctor Skepticism on Safety Profile",
        "avgOverallScore": 4.6,
        "avgDurationSeconds": 889,
        "totalSessions": 366,
        "avgSessionsPerActiveUser": 6.2,
        "teamUuids": [
        "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a",
        "5d6e7f8a-9b2c-4d8f-92e5-3b7e8c9f0a4b"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c14dbf0",
        "simulationName": "Competitor Efficacy Comparison",
        "avgOverallScore": 2.8,
        "avgDurationSeconds": 1331,
        "totalSessions": 350,
        "avgSessionsPerActiveUser": 5.7,
        "teamUuids": [
        "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a",
        "5d6e7f8a-9b2c-4d8f-92e5-3b7e8c9f0a4b"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afb",
        "uuid": "8de66fb2-a0ec-485b-b640-1d6cf9727b20",
        "simulationName": "Switching from a Biologic",
        "avgOverallScore": 3.8,
        "avgDurationSeconds": 397,
        "totalSessions": 270,
        "avgSessionsPerActiveUser": 6.2,
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afb",
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c14dbf1",
        "simulationName": "Overcoming Access Barriers",
        "avgOverallScore": 4.2,
        "avgDurationSeconds": 264,
        "totalSessions": 268,
        "avgSessionsPerActiveUser": 5.3,
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afb",
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c14dcf0",
        "simulationName": "Balancing Efficacy and Safety",
        "avgOverallScore": 4.8,
        "avgDurationSeconds": 433,
        "totalSessions": 178,
        "avgSessionsPerActiveUser": 9.1,
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afa",
        "uuid": "8de66fb2-a0ec-485b-b640-1d6cf9737b20",
        "simulationName": "Tailoring the Visual Aid to the Customer",
        "avgOverallScore": 3.7,
        "avgDurationSeconds": 734,
        "totalSessions": 318,
        "avgSessionsPerActiveUser": 5.7,
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afa",
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c24dbf1",
        "simulationName": "Telling the Rukagen Story",
        "avgOverallScore": 4.6,
        "avgDurationSeconds": 843,
        "totalSessions": 238,
        "avgSessionsPerActiveUser": 6.3,
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afa",
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c74dcf0",
        "avgOverallScore": 4.8,
        "avgDurationSeconds": 576,
        "totalSessions": 160,
        "avgSessionsPerActiveUser": 8.9,
        "simulationName": "Reinforcing Key Takeaways",
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afd",
        "uuid": "8de66fb2-a0ec-488b-b640-1d6cf9737b20",
        "simulationName": "Beyond Joints: The Whole-Patient Conversation",
        "avgOverallScore": 4.2,
        "avgDurationSeconds": 397,
        "totalSessions": 448,
        "avgSessionsPerActiveUser": 6.7,
        "teamUuids": [
        "2c3d4e5f-6a7b-8c9d-97e0-8a2b3c4d5e9f",
        "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a"
        ]
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afd",
        "uuid": "ffa7b9bc-0af1-461f-81f0-a4fc9c24dbf1",
        "simulationName": "The Cost Conversation: Value in a Budget-Constrained Setting",
        "avgOverallScore": 2.8,
        "avgDurationSeconds": 464,
        "totalSessions": 268,
        "avgSessionsPerActiveUser": 3.2,
        "teamUuids": [
        "2c3d4e5f-6a7b-8c9d-97e0-8a2b3c4d5e9f",
        "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a"
        ]
    }
]

